import { colorsPrimitive as colors } from "./colorsPrimitive";

export const colorsBackground = {
	bg_primary: colors.primary.base["white"],
	bg_primary_dark: colors.primary.grayDark[950],
	bg_primary_alt: colors.primary.base["white"],
	bg_primary_alt_dark: colors.primary.grayDark[900],
	bg_primary_hover: colors.primary.grayLight[50],
	bg_primary_hover_dark: colors.primary.grayDark[800],

	bg_primary_solid: colors.primary.grayLight[950],
	bg_primary_solid_dark: colors.primary.grayLight[900],

	bg_secondary: colors.primary.grayLight[50],
	bg_secondary_dark: colors.primary.grayDark[900],
	bg_secondary_alt: colors.primary.grayLight[50],
	bg_secondary_alt_dark: colors.primary.grayDark[950],
	bg_secondary_hover: colors.primary.grayLight[100],
	bg_secondary_hover_dark: colors.primary.grayDark[800],
	bg_secondary_subtle: colors.primary.grayLight[25],
	bg_secondary_subtle_dark: colors.primary.grayDark[900],

	bg_secondary_solid: colors.primary.grayLight[600],
	bg_secondary_solid_dark: colors.primary.grayLight[600],

	bg_tertiary: colors.primary.grayLight[100],
	bg_tertiary_dark: colors.primary.grayLight[800],

	bg_quaternary: colors.primary.grayLight[200],
	bg_quaternary_dark: colors.primary.grayLight[700],

	bg_active: colors.primary.grayLight[50],
	bg_active_dark: colors.primary.grayDark[800],

	bg_disabled: colors.primary.grayLight[100],
	bg_disabled_dark: colors.primary.grayDark[800],
	bg_disabled_subtle: colors.primary.grayLight[50],
	bg_disabled_subtle_dark: colors.primary.grayDark[900],

	bg_overlay: colors.primary.grayLight[950],
	bg_overlay_dark: colors.primary.grayDark[800],

	bg_brand_primary: colors.primary.brand[50],
	bg_brand_primary_dark: colors.primary.brand[500],
	bg_brand_primary_alt: colors.primary.brand[50],
	bg_brand_primary_alt_dark: colors.primary.grayDark[800],

	bg_brand_secondary: colors.primary.brand[100],
	bg_brand_secondary_dark: colors.primary.brand[600],

	bg_brand_solid: colors.primary.brand[600],
	bg_brand_solid_dark: colors.primary.brand[600],
	bg_brand_solid_hover: colors.primary.brand[700],
	bg_brand_solid_hover_dark: colors.primary.brand[500],

	bg_brand_section: colors.primary.brand[800],
	bg_brand_section_dark: colors.primary.grayDark[800],
	bg_brand_section_subtle: colors.primary.brand[700],
	bg_brand_section_subtle_dark: colors.primary.grayDark[950],

	bg_error_primary: colors.primary.error[50],
	bg_error_primary_dark: colors.primary.error[950],
	bg_error_secondary: colors.primary.error[100],
	bg_error_secondary_dark: colors.primary.grayDark[600],
	bg_error_solid: colors.primary.error[600],
	bg_error_solid_dark: colors.primary.error[600],
	bg_error_solid_hover: colors.primary.error[700],
	bg_error_solid_hover_dark: colors.primary.error[500],

	bg_warning_primary: colors.primary.warning[50],
	bg_warning_primary_dark: colors.primary.warning[950],
	bg_warning_secondary: colors.primary.warning[100],
	bg_warning_secondary_dark: colors.primary.warning[600],
	bg_warning_solid: colors.primary.warning[600],
	bg_warning_solid_dark: colors.primary.warning[600],

	bg_success_primary: colors.primary.success[50],
	bg_success_primary_dark: colors.primary.success[950],
	bg_success_secondary: colors.primary.success[100],
	bg_success_secondary_dark: colors.primary.success[950],
	bg_success_solid: colors.primary.success[600],
	bg_success_solid_dark: colors.primary.success[600],
};
